import SignupHeroMedia from './SignupHeroMedia'

export default SignupHeroMedia
